import ControlledDatePicker from "./ControlledDatePicker/ControlledDatePicker";

import greyPlus from "./PlusCircle.svg";
import redPlus from "./RedRotatedPlusCircle.svg";
import bluePlus from "./BluePlusCircle.svg";

import {
    addPeriodHandlerCurrentRequest,
} from "../../../../redux/actions/Requests/currentRequestControls/addPeriodHandler.currentRequest";
import {
    deletePeriodHandlerCurrentRequest,
} from "../../../../redux/actions/Requests/currentRequestControls/deletePeriodHandler.currentRequest";

import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import React, { memo } from "react";
import { ClipLoader } from "react-spinners";
import moment from "moment";

function pluralDays(n) {
    const mod10 = n % 10;
    const mod100 = n % 100;
    if (mod10 === 1 && mod100 !== 11) return "день";
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return "дня";
    return "дней";
}

function calendarAdjective(n) {
    const mod10 = n % 10;
    const mod100 = n % 100;
    return mod10 === 1 && mod100 !== 11 ? "календарный" : "календарных";
}

// Количество выбранных календарных дней в периоде (включительно), не рабочих —
// в отличие от withControledInput/days, который приходит с бэка отдельным запросом.
function getCalendarDaysCount(dateFrom, dateTo) {
    if (!dateFrom || !dateTo) return null;
    return moment(dateTo).diff(moment(dateFrom), "days") + 1;
}

const BlueButton = ({ parentStyle, setState }) => {

    const dispatch = useDispatch();

    function addPeriodHandler(e) {
        dispatch(addPeriodHandlerCurrentRequest());
    }

    return (
        <img
            onClick={addPeriodHandler}
            className={`${parentStyle}-date-period__blue-plus`}
            src={bluePlus}
            alt="bluePlus" />
    );
};

const RedButton = ({ parentStyle, setState, index,withControledInput }) => {

    const dispatch = useDispatch();

    function deletePeriodHandler(e) {
        dispatch(deletePeriodHandlerCurrentRequest(index));
        // if(withControledInput){
        //     dispatch(getEmployeeWorkDaysThunkAction({
        //         periods: currentRequest?.periods,
        //         setDays: setDays,
        //         field: "periods" }));
        // }

    }

    return (
        <img
            onClick={deletePeriodHandler}
            className={`${parentStyle}-date-period__red-plus`}
            src={redPlus}
            alt="redPlus" />
    );
};

const GreyButton = ({ parentStyle }) => {
    return (
        <img
            className={`${parentStyle}-date-period__grey-plus`}
            src={greyPlus}
            alt="greyPlus" />
    );
};


const DatePeriodControlled = (
    {
        requestState,
        // setRequestState,
        parentStyle,
        // setPeriods,
        period,
        index,
        periodsLength,
        label,
        datesForRange,
        withControledInput,
        handler,
        allowsMultipleDateRanges,
        days,
    },
) => {
    const currentRequest = useSelector(state => state.requests.currentRequest);
    const calendarDaysCount = getCalendarDaysCount(period.dateFrom, period.dateTo);

    return (
        <div key={uuidv4()} className={`${parentStyle}-date-period`}>
            <div className={`${parentStyle}-date-period__row`}>
                <div className={`${parentStyle}-date-period__input-wrapper`}>
                    <div className={`${parentStyle}-date-period__from`}>
                        <ControlledDatePicker
                            period={period}
                            highlightDates={currentRequest &&
                                currentRequest.periods &&
                                currentRequest.periods[index] &&
                                currentRequest.periods[index].days &&
                                currentRequest.periods[index].days?.length ?
                                currentRequest.periods[index].days.map(el => new Date(el)) : null}
                            requestState={requestState}
                            date={period.dateFrom}
                            index={index}
                            field={"dateFrom"}
                            parentStyle={parentStyle}
                            label={label ? label.from : "Начало перенесенного отпуска *"}
                            handler={handler}
                            datesForRange={datesForRange} />
                    </div>
                    <div className={`${parentStyle}-date-period__to`}>
                        <ControlledDatePicker
                            period={period}
                            highlightDates={currentRequest &&
                            currentRequest.periods &&
                            currentRequest.periods[index] &&
                            currentRequest.periods[index].days?.length ?
                                currentRequest.periods[index].days.map(el => new Date(el)) : null}
                            requestState={requestState}
                            date={period.dateTo}
                            index={index}
                            field={"dateTo"}
                            parentStyle={parentStyle}
                            handler={handler}
                            label={label ? label.to : "Окончание перенесенного отпуска *"} />
                    </div>
                    {
                        withControledInput && (index === currentRequest?.periods?.length - 1) ?
                            <div style={{ fontSize: "12px",
                                lineHeight: "19px",
                                display: "flex",
                                flexDirection: "column",
                            }}>
                                <label style={{
                                    color: days?.error?
                                        "red" : "black",
                                }} > { days?.error?
                                    days?.error :  "Кол - во дней отдыха "  }
                                <div
                                    style={{ fontSize: "16px", textAlign: "center" }}
                                > {
                                    days.loading
                                   ? <ClipLoader  size={32} color="#6DCDF6"/>
                                    :days.count ?
                                    days.count : "0"
                                }  </div> </label>
                            </div>
                            : null

                    }
                </div>
                <div className={`${parentStyle}-date-period__controllers`}>
                    {periodsLength > 1 &&
              <RedButton
                  // setDays={setDays}
                  // currentRequest={currentRequest}

                  parentStyle={parentStyle}
                  index={index}
              />}
                    {

                        (allowsMultipleDateRanges ) ?
                        !period.dateFrom || !period.dateTo
                            ? <GreyButton parentStyle={parentStyle} />
                            : index === periodsLength - 1
                                ? <BlueButton
                                    parentStyle={parentStyle}
                                />
                                : null
                            : null
                    }

                </div>
            </div>
            {
                allowsMultipleDateRanges && calendarDaysCount !== null &&
                    <div className={`${parentStyle}-date-period__days-count`}>
                        {calendarDaysCount} {calendarAdjective(calendarDaysCount)} {pluralDays(calendarDaysCount)}
                    </div>
            }
        </div>
    );
};

export default memo(DatePeriodControlled);
